import { Button } from '@/components/shadcn/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/shadcn/ui/dialog';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/ui/form';
import { Input } from '@/components/shadcn/ui/input';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { toast } from '@/components/shadcn/ui/use-toast';
import { zodResolver } from '@hookform/resolvers/zod';
import { PlusIcon, BoxIcon, EditIcon } from 'lucide-react';
import { ChangeEvent, FormEvent, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useProductWithBusinessContext } from './ProductWithBusinessContext';
import React from 'react';
const schema = z.object({
  id: z.number().optional(),
  productId: z.number(),
  commission: z.number(),
  quantity: z.number(),
  price: z.number(),
  discount: z.number(),
  total: z.number()
});

type ProductProps = {
    onProductUpdateSubmit: (data:any) => void;
}
// eslint-disable-next-line
const EditProductForm:React.FC<ProductProps> = ({onProductUpdateSubmit}) => {
  const form = useForm({
    resolver: zodResolver(schema),
  });
  const {openEdit, product2Edit, setOpenEdit} = useProductWithBusinessContext();
  const {updateBusinessProduct} = useProductWithBusinessContext(); 

  useEffect(() => {
    if (product2Edit) {
      form.reset({
        id: product2Edit.id,
        productId: product2Edit.productId,
        commission: product2Edit.commission,
        quantity: product2Edit.quantity,
        price: product2Edit.price,
        discount: product2Edit.discount,
        total: product2Edit.total
      });
    }
  }, [product2Edit, form]);

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    onProductUpdateSubmit(form.getValues());
  }

  function phoneInputChange(e: ChangeEvent<HTMLInputElement>) {
    throw new Error('Function not implemented.');
  }

  function percentageInputChange(e: ChangeEvent<HTMLInputElement>) {
    throw new Error('Function not implemented.');
  }

  return (
    <Dialog open = {openEdit} onOpenChange={()=>{
      setOpenEdit(!openEdit);
      
    }}>
      <DialogTrigger >
        {/* <div className=''>
          <Button variant='ghost' className='gap-1 mt-2 bg-indigo-50 hover:bg-indigo-100' > 
            <EditIcon size={12}/> 
            Editar Produto
          </Button>
        </div> */}
      </DialogTrigger> 
      <DialogContent className='w-4/5 h-[70%]'> 
        <DialogHeader>
          <DialogTitle>
            <div className='flex items-center gap-2'>
              <EditIcon/>  
              Editar Produto 
            </div>
          </DialogTitle>
        </DialogHeader>
            
        {/* Começo do Formulário */}
        <Form {...form}>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className='grid gap-4 pt-2'>
      
              {/* id */}
              <FormField
                control={form.control}
                name="id"
                render={({ field }) => (
                  <input type="hidden" onChange={(e) => {
                    field.onChange(e);
                  }} defaultValue={product2Edit ? product2Edit.id : 0} />
                )}
              />
      
              {/* quantidade */}
              <FormField
                control={form.control}
                name="quantity"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Quantidade</FormLabel>
                    <FormControl>
                      <Input 
                        placeholder={'Digite a quantidade'}
                        defaultValue={product2Edit ? product2Edit.quantity : 0}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
      
              {/* Preço */}
              <FormField
                control={form.control}
                name='price'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Preço</FormLabel>
                    <FormControl>
                      <Input
                        placeholder={'Digite o preço do produto'}
                        defaultValue={product2Edit ? product2Edit.price : 0}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
      
              {/* Desconto */}
              <FormField
                control={form.control}
                name='discount'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Desconto</FormLabel>
                    <FormControl>
                      <Input placeholder={'Digite o valor do desconto'}
                        defaultValue={product2Edit ? product2Edit.discount : ''}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <DialogFooter>
              <Button type='submit' className='bg-indigo-700' onClick={()=>{
                const data = form.getValues();
                form.setValue('total', (data.price * data.quantity) - data.discount);
                form.setValue('productId', product2Edit ? product2Edit.productId : 0);
                console.log(data);
                setOpenEdit(false);
              }}>Editar Indicador</Button>
            </DialogFooter>
          </form>
        </Form> 
      </DialogContent> 
    </Dialog>
  );
};

export default EditProductForm;
